// Safely extracts a human-readable string from an axios error, regardless of whether the
// backend returned a plain string detail (HTTPException) or FastAPI's 422 validation
// envelope (detail = [{type, loc, msg, input}, ...]) - passing the latter straight into a
// toast crashes React with "Objects are not valid as a React child".
export function getApiErrorMessage(error, fallback = "Ocorreu um erro") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const msgs = detail.map((d) => (typeof d === "string" ? d : d?.msg)).filter(Boolean);
    if (msgs.length > 0) return msgs.join("; ");
  }
  return error?.message || fallback;
}
